module.exports = __webpack_public_path__ + "img/haofeng.8f00f9c2.png";